import Repository from "./Repository";

export default {
  // Get All Admins
  getAdminUsers() {
    return Repository.get(`/admin/aspire_admin`);
  },

  // Get Admin By Email
  getAdminUser(email) {
    return Repository.get(`/admin/aspire_admin/${email}`);
  },

  // Update Admin User
  updateAdminUser(payload) {
    const email = payload.email;
    return Repository.put(`/admin/aspire_admin/${email}`, payload.data);
  },

  // Delete Admin
  deleteAdminUser(email) {
    return Repository.delete(`/admin/aspire_admin/${email}`);
  },

  // Invite Admin
  inviteAdmin(payload) {
    return Repository.post(`/admin/aspire_admin/invite`, payload);
  }
};
